module.exports = __webpack_public_path__ + "store/img/shop-tags-personalize-qr.e51d14a6.png";